export class MapFilter {
  centerLat: number;
  centerLng: number;
  zoomLevel: number;
}
